import React, { useState } from 'react';
import API from '../services/api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import '../App.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleLogin = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        setLoading(true);
        try {
            console.log("Attempting login with:", email, password);
            const response = await API.post('/login', { email, password });
            const data = response.data || {};

            // If backend returned 2FA requirement
            if (data["2fa_required"]) {
                localStorage.setItem('userEmail', email);
                toast.info(data.message || 'Enter the 2FA code sent to your email.');
                return navigate('/verify-2fa');
            }

            const { access_token, user } = data;

            // If account exists but is not verified, send to verify page
            if (user && user.is_verified === false) {
                console.log("User not verified, redirecting to /verify");

                localStorage.setItem('userEmail', email);
                toast.warning("Please verify your email before continuing.");
                console.log("Stored userEmail in localStorage:");
                return navigate('/verify');
            }

            if (!access_token) {
                return toast.error("Login failed: token missing.");
            }

            localStorage.setItem('token', access_token);
            localStorage.setItem('userEmail', email);
            localStorage.setItem('username', response.data.username);
            toast.success("Welcome Back!");
            navigate('/dashboard');
        } catch (error) {
            const errorDetail = error.response?.data?.detail;
            const normalized = typeof errorDetail === 'string' ? errorDetail.toLowerCase() : '';

            if (normalized.includes("not verified")) {
                localStorage.setItem('userEmail', email);
                toast.warning("Email not verified. Redirecting...");
                return navigate('/verify');
            }

            toast.error(errorDetail || "Login Failed");
        } finally {
            setLoading(false);
        }
    };

    return (

        <div className="main-bg">

            {/* Left Side: Modern Branding */}
            <div className="brand-section">
                <h1>Cortex</h1>
                <p>Manage your tasks with elegance and clarity.<br/>Your productivity, reimagined.</p>
            </div>

            {/* Right Side: Glassmorphism Card */}
            <div className="auth-container">
                <h2>Login</h2>
                <p className="sub-text" style={{ color: 'white', marginBottom: '30px' }}>
    Please enter your details
</p>
                <form onSubmit={handleLogin}>
                    <input
                        type="email"
                        placeholder="Email Address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        placeholder="Password"

                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required

                    />

                    <button type="submit" disabled={loading} style={{
                        opacity: loading ? 0.6 : 1,
                        cursor: loading ? 'not-allowed' : 'pointer'
                    }}>
                        {loading ? <span className="spinner"></span> : "Login"}
                    </button>


                    {/* Forgot Password Section */}


                    <p style={{ marginTop: '15px' }}>


                        <span className="white-link"

                              style={{ fontSize: '13px', borderBottom: '1px solid rgba(0, 210, 255, 0.4)' }}

                              onClick={() => navigate('/forgot-password')}>

                            Forgot Password?

                        </span>

                    </p>

                </form>

                <div style={{ marginTop: '25px' }}>
                    <p style={{ marginTop: '20px' }}>New here? <span className="white-link" onClick={() => navigate('/signup')}>Create Account</span></p>
                </div>

                <div style={{ marginTop: '20px' }}>
                    <p>OR</p>
                    <button
                        className="google-btn"
                        onClick={() => {
                            const backend = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
                            window.location.href = `${backend.replace(/\/$/, '')}/auth/google/login`;
                        }}
                        style={{ marginTop: '8px' }}
                        aria-label="Continue with Google"
                    >
                        <span className="google-logo" aria-hidden="true">
                            <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                              <g fill="none" fillRule="evenodd">
                                <path d="M17.64 9.2c0-.63-.06-1.23-.17-1.81H9v3.44h4.84c-.21 1.12-.86 2.07-1.84 2.7v2.25h2.98c1.75-1.61 2.77-3.99 2.77-6.58z" fill="#4285F4"/>
                                <path d="M9 18c2.43 0 4.47-.8 5.96-2.17l-2.98-2.25c-.83.56-1.9.9-2.98.9-2.29 0-4.23-1.54-4.92-3.61H1.06v2.27C2.53 15.8 5.56 18 9 18z" fill="#34A853"/>
                                <path d="M4.08 10.87A5.41 5.41 0 013.6 9c0-.62.11-1.22.48-1.87V4.86H1.06A8.99 8.99 0 000 9c0 1.45.35 2.82.96 4.02l3.12-2.15z" fill="#FBBC05"/>
                                <path d="M9 3.58c1.32 0 2.52.45 3.46 1.33l2.59-2.59C13.45.99 11.42 0 9 0 5.56 0 2.53 2.2 1.06 4.86l3.02 2.27C4.77 5.12 6.71 3.58 9 3.58z" fill="#EA4335"/>
                              </g>
                            </svg>
                        </span>
                        Continue with Google
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Login;